function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppLogo = function SvgAppLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.1 192.2",
    style: {
      enableBackground: "new 0 0 198.1 192.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 99,
    cy: 96.1,
    rx: 91,
    ry: 90.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#4B4B4B"
    },
    cx: 99,
    cy: 96.1,
    rx: 58.2,
    ry: 57.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B4B4B"
    },
    d: "M99,10.2c-47.7,0-86.4,38.4-86.4,85.9s38.7,85.9,86.4,85.9s86.4-38.4,86.4-85.9S146.7,10.2,99,10.2 z M99,155.9c-33.2,0-60.2-26.8-60.2-59.8s27-59.8,60.2-59.8s60.2,26.8,60.2,59.8S132.2,155.9,99,155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B4B4B"
    },
    d: "M99,4.6C48.3,4.6,7,45.6,7,96.1s41.3,91.5,92.1,91.5s92.1-41,92.1-91.5S149.8,4.6,99,4.6z  M99,186.1c-50,0-90.6-40.4-90.6-90S49.1,6,99,6s90.6,40.4,90.6,90S149,186.1,99,186.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36.8,140.9l6.3-5l1,1.3l-2.5,2l2,2.5l2.5-2l1,1.3l-6.3,5l-1-1.3l2.7-2.2l-2-2.5l-2.7,2.2 L36.8,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M49.8,143.9L51,145l-2.9,3.2c-0.5,0.5-0.8,0.8-0.9,1c-0.2,0.3-0.2,0.6-0.2,0.9 c0.1,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.7,0.5,1,0.5c0.3,0,0.6-0.1,0.8-0.2c0.2-0.2,0.5-0.5,1-1l3-3.3l1.2,1.1l-2.9,3.1 c-0.7,0.7-1.1,1.2-1.5,1.4c-0.3,0.2-0.7,0.4-1,0.4c-0.4,0-0.7,0-1.1-0.2c-0.4-0.1-0.8-0.4-1.3-0.9c-0.6-0.5-0.9-1-1.1-1.4 c-0.2-0.4-0.2-0.8-0.2-1.1c0-0.4,0.1-0.7,0.3-1c0.2-0.4,0.7-0.9,1.3-1.6L49.8,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M53.3,157.5l4.4-6.7l2,1.3l-1.8,5.4l4.2-3.8l2,1.3l-4.4,6.7l-1.3-0.8l3.5-5.3l-4.8,4.4l-1.3-0.9 l2.2-6.1l-3.5,5.3L53.3,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M71.1,167.3l-1.6-0.7l0.1-2l-2.9-1.3l-1.4,1.4l-1.6-0.7l6.1-6l1.6,0.7L71.1,167.3z M69.6,163.2 l0.2-3.2l-2.2,2.3L69.6,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M75.3,168.8l2.1-7.7l1.5,0.4l1.7,6l1.4-5.2l1.5,0.4l-2.1,7.7l-1.6-0.4l-1.7-5.9l-1.4,5L75.3,168.8z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.8,169.6l1.6-0.1c0.1,0.5,0.3,0.9,0.5,1.2c0.3,0.3,0.7,0.4,1.2,0.4c0.5,0,0.9-0.1,1.2-0.3 c0.3-0.2,0.4-0.5,0.4-0.8c0-0.2,0-0.4-0.1-0.5s-0.3-0.3-0.6-0.4c-0.2-0.1-0.6-0.2-1.3-0.4c-0.9-0.2-1.5-0.5-1.8-0.9 c-0.5-0.5-0.7-1-0.7-1.6c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8c0.4-0.2,1-0.2,1.6-0.2c1,0,1.8,0.3,2.2,0.7s0.7,1.1,0.7,1.8 l-1.6,0c-0.1-0.4-0.2-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3c-0.5,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.2,0.1,0.4,0.2,0.5 c0.2,0.2,0.7,0.4,1.5,0.6c0.8,0.2,1.4,0.4,1.7,0.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.4,0.3,0.8,0.3,1.3c0,0.5-0.2,0.9-0.4,1.3 c-0.3,0.4-0.6,0.7-1.1,0.9s-1.1,0.3-1.8,0.2c-1,0-1.8-0.3-2.3-0.8C93.1,171.2,92.8,170.5,92.8,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M104.1,172.3l-0.8-8l5.9-0.6l0.1,1.4l-4.3,0.4l0.2,1.8l4-0.4l0.1,1.3l-4,0.4l0.2,2.2l4.5-0.5 l0.1,1.3L104.1,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.1,170.8l-2-7.8l3.3-0.8c0.8-0.2,1.5-0.3,1.9-0.3c0.4,0,0.8,0.2,1.1,0.5 c0.3,0.3,0.5,0.7,0.7,1.1c0.1,0.6,0.1,1.1-0.1,1.6c-0.2,0.5-0.7,0.8-1.4,1.1c0.4,0.1,0.7,0.3,1,0.4c0.3,0.2,0.7,0.5,1.2,1l1.3,1.3 l-1.9,0.5l-1.6-1.4c-0.6-0.5-0.9-0.8-1.1-0.9c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5,0-0.8,0.1l-0.3,0.1l0.8,3.2L115.1,170.8z  M115.6,165.9l1.2-0.3c0.8-0.2,1.2-0.3,1.4-0.5c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.1-0.4,0-0.6c-0.1-0.3-0.2-0.5-0.4-0.6 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.1,0-0.5,0.1-1.2,0.3l-1.2,0.3L115.6,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128.1,166.8l-5.8-6.3l1.6-0.7l4.2,4.7l-0.5-6.2l1.6-0.7l0.5,8.5L128.1,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136,163l-3.9-7l1.4-0.8l3.9,7L136,163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.2,154.2l1.6-0.5c0.3,0.9,0.4,1.6,0.2,2.3c-0.2,0.7-0.7,1.3-1.3,1.8c-0.9,0.6-1.8,0.8-2.8,0.7 c-1-0.2-1.8-0.8-2.6-1.8c-0.8-1.1-1.1-2.1-1-3.1c0.1-1,0.6-1.8,1.5-2.5c0.8-0.6,1.6-0.8,2.4-0.7c0.5,0.1,1,0.3,1.5,0.7l-1.1,1.3 c-0.3-0.3-0.7-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.4c-0.5,0.4-0.7,0.8-0.8,1.4s0.2,1.2,0.8,2c0.6,0.8,1.2,1.3,1.7,1.4 c0.5,0.1,1.1,0,1.5-0.3c0.3-0.3,0.6-0.6,0.7-1C144.5,155.2,144.4,154.7,144.2,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151,152.4l-5.6-5.7l4.2-4.2l1,1l-3.1,3l1.2,1.3l2.9-2.8l0.9,1l-2.9,2.8l1.5,1.6l3.2-3.1l0.9,1 L151,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M156.3,143.1l0.8-1.3c0.5,0.2,0.9,0.3,1.3,0.2c0.4-0.1,0.7-0.3,1-0.7c0.3-0.4,0.5-0.8,0.5-1.1 c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.1-0.5,0.4-1.1,0.8c-0.7,0.6-1.3,0.9-1.7,1 c-0.6,0.1-1.2,0-1.7-0.4c-0.3-0.2-0.6-0.6-0.7-1c-0.1-0.4-0.2-0.8,0-1.3c0.1-0.5,0.4-0.9,0.7-1.4c0.6-0.8,1.2-1.3,1.9-1.4 c0.7-0.1,1.3,0,1.9,0.4l-0.9,1.3c-0.4-0.2-0.7-0.3-1-0.2c-0.3,0.1-0.6,0.3-0.8,0.7c-0.3,0.4-0.4,0.7-0.4,1.1 c0,0.2,0.1,0.4,0.2,0.5c0.2,0.1,0.3,0.1,0.5,0.1c0.3-0.1,0.7-0.3,1.3-0.9c0.6-0.5,1.1-0.9,1.5-1c0.4-0.2,0.8-0.3,1.2-0.2 c0.4,0,0.8,0.2,1.2,0.5c0.4,0.3,0.6,0.6,0.8,1.1c0.2,0.4,0.2,0.9,0.1,1.4c-0.1,0.5-0.4,1-0.8,1.6c-0.6,0.8-1.3,1.3-2,1.4 C157.8,143.7,157,143.6,156.3,143.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M32.6,76.7l-0.4,1.8l-2.1,0.3l-0.8,3.3l1.7,1.1L30.7,85l-7.6-5.2l0.4-1.8L32.6,76.7z M28.6,79 l-3.4,0.4l2.8,1.8L28.6,79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M33.2,74.9l-8-3.1l1.3-3.4c0.3-0.8,0.6-1.4,0.9-1.8c0.3-0.3,0.7-0.5,1.1-0.6c0.5-0.1,0.9,0,1.4,0.1 c0.6,0.2,1,0.6,1.3,1.1c0.3,0.5,0.3,1.1,0.1,1.9c0.3-0.3,0.7-0.5,1-0.6c0.3-0.1,0.9-0.3,1.6-0.4l1.9-0.4l-0.7,1.9l-2.2,0.5 c-0.8,0.2-1.3,0.3-1.5,0.4c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1-0.3,0.4-0.4,0.8L30.5,72l3.3,1.3L33.2,74.9z M29.3,71.5l0.5-1.2 c0.3-0.8,0.5-1.3,0.5-1.5c0-0.2,0-0.4-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.3-0.1-0.5-0.1-0.7,0c-0.2,0.1-0.4,0.2-0.5,0.5 c-0.1,0.1-0.2,0.5-0.5,1.2l-0.5,1.3L29.3,71.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36.9,66.1l-7.4-4.2l0.8-1.5l3.3,1.9L32,57.4l1.1-2l1.3,4.4l6.2-0.4l-1.1,1.9l-4.6,0.1l0.6,1.9 l2.2,1.3L36.9,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M46.4,51.8l-1.1,1.5l-2-0.6l-2.1,2.7l1.1,1.7l-1.1,1.5l-4.8-7.8l1.1-1.4L46.4,51.8z M41.7,52.3 l-3.2-1l1.8,2.8L41.7,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M47.6,50.5l-6-6.1l1.2-1.2l6.5,1.6l-4-4.1l1.1-1.1l6,6.1l-1.2,1.2l-6.4-1.5l3.9,4L47.6,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M52.5,42l1.2-1.1c0.4,0.4,0.8,0.6,1.2,0.6c0.4,0,0.8-0.1,1.2-0.4c0.4-0.3,0.7-0.7,0.8-1 c0.1-0.4,0-0.7-0.2-0.9c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2,0-0.4,0-0.7,0.1c-0.2,0.1-0.6,0.2-1.3,0.5c-0.9,0.4-1.6,0.5-2.1,0.5 c-0.7-0.1-1.3-0.4-1.7-0.9c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.5,0.1-0.9,0.3-1.3c0.3-0.4,0.6-0.9,1.2-1.2c0.9-0.6,1.6-0.9,2.4-0.9 c0.7,0.1,1.3,0.4,1.8,1l-1.3,1.1c-0.3-0.3-0.6-0.5-0.9-0.5c-0.3,0-0.7,0.1-1,0.4c-0.4,0.3-0.7,0.6-0.8,1c-0.1,0.2,0,0.4,0.1,0.6 c0.1,0.2,0.3,0.2,0.5,0.3c0.3,0,0.8-0.1,1.6-0.5c0.8-0.3,1.4-0.6,1.9-0.6c0.4-0.1,0.9,0,1.3,0.1c0.4,0.2,0.8,0.5,1.1,0.9 c0.3,0.4,0.5,0.8,0.5,1.3c0,0.5-0.1,1-0.4,1.5c-0.3,0.5-0.7,0.9-1.3,1.4c-0.9,0.6-1.7,0.9-2.4,0.9C53.9,43,53.2,42.7,52.5,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.4,35l-1.6,0.9l-1.6-1.3l-3,1.7l0.3,2L61,39.2l-1.3-9.1l1.6-0.9L68.4,35z M64,33.6l-2.6-2.2 l0.5,3.3L64,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.7,31.8l1.5-0.8c0.3,0.5,0.6,0.8,1,0.9c0.4,0.1,0.8,0.1,1.3-0.1c0.5-0.2,0.9-0.5,1-0.8 c0.2-0.3,0.2-0.6,0.1-0.9c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1c-0.2,0-0.7,0.1-1.4,0.2c-0.9,0.1-1.6,0.1-2.1-0.1 c-0.7-0.2-1.1-0.7-1.4-1.3c-0.2-0.4-0.2-0.8-0.1-1.3c0.1-0.4,0.3-0.8,0.7-1.2c0.4-0.4,0.8-0.7,1.5-0.9c1-0.4,1.8-0.5,2.5-0.2 c0.7,0.2,1.2,0.7,1.5,1.4L72.2,27c-0.2-0.4-0.5-0.6-0.8-0.7c-0.3-0.1-0.7,0-1.1,0.1c-0.5,0.2-0.8,0.4-1,0.7 c-0.1,0.2-0.1,0.4-0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.3,0.1,0.8,0.1,1.7,0c0.9-0.1,1.5-0.2,2-0.1c0.5,0.1,0.8,0.2,1.2,0.5 c0.3,0.3,0.6,0.6,0.8,1.1c0.2,0.5,0.2,0.9,0.1,1.4c-0.1,0.5-0.3,0.9-0.7,1.3c-0.4,0.4-0.9,0.7-1.6,1c-1,0.4-1.9,0.5-2.6,0.2 C69.7,33.2,69.2,32.7,68.7,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M81.2,21.7l3.1-0.5C85,21,85.5,21,85.9,21c0.5,0.1,1,0.2,1.4,0.6c0.4,0.3,0.8,0.7,1,1.2 c0.3,0.5,0.5,1.2,0.6,1.9c0.1,0.7,0.1,1.3,0.1,1.8c-0.1,0.6-0.3,1.2-0.6,1.6c-0.2,0.3-0.6,0.6-1.1,0.9c-0.4,0.2-0.8,0.3-1.5,0.4 l-3.2,0.6L81.2,21.7z M83.1,22.8l1,5.6l1.3-0.2c0.5-0.1,0.8-0.2,1-0.3c0.3-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.3-0.5,0.3-0.9 c0-0.4,0-0.9-0.1-1.6c-0.1-0.6-0.3-1.1-0.4-1.5c-0.2-0.3-0.4-0.6-0.6-0.7c-0.2-0.2-0.5-0.2-0.9-0.3c-0.2,0-0.7,0-1.4,0.2 L83.1,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.1,28.6l-0.3-8.5l6.3-0.3l0.1,1.4l-4.6,0.2l0.1,1.9l4.3-0.2l0.1,1.4l-4.3,0.2l0.1,2.3l4.8-0.2 l0.1,1.4L92.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M101,28.4l0.7-8.5l2.8,0.2c1,0.1,1.7,0.2,2,0.3c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.5,0.4,1,0.3,1.7 c0,0.5-0.2,1-0.4,1.3c-0.2,0.3-0.5,0.6-0.8,0.8c-0.3,0.2-0.6,0.3-0.9,0.3c-0.4,0-1,0-1.8,0l-1.1-0.1l-0.3,3.2L101,28.4z  M103.3,21.5l-0.2,2.4L104,24c0.7,0.1,1.1,0.1,1.4,0c0.2-0.1,0.4-0.2,0.6-0.4c0.1-0.2,0.2-0.4,0.3-0.6c0-0.3,0-0.6-0.2-0.8 c-0.2-0.2-0.4-0.4-0.7-0.4c-0.2-0.1-0.6-0.1-1.2-0.2L103.3,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.5,30.8l-1.8-0.4l-0.3-2.1l-3.3-0.7l-1.1,1.7l-1.8-0.4l5-7.7l1.8,0.4L116.5,30.8z M114.1,26.9 l-0.5-3.3l-1.8,2.9L114.1,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118.2,31.4l2.9-8l3.4,1.2c0.9,0.3,1.5,0.6,1.8,0.9c0.3,0.3,0.6,0.7,0.7,1.1 c0.1,0.5,0.1,0.9-0.1,1.4c-0.2,0.6-0.6,1-1.1,1.3c-0.5,0.3-1.1,0.3-1.9,0.2c0.3,0.3,0.5,0.7,0.6,1c0.1,0.3,0.3,0.9,0.4,1.6 l0.4,1.9l-1.9-0.7l-0.5-2.2c-0.2-0.8-0.3-1.3-0.4-1.5c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.4-0.3-0.8-0.4l-0.3-0.1l-1.2,3.3 L118.2,31.4z M121.5,27.3l1.2,0.4c0.8,0.3,1.3,0.4,1.5,0.4c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.3,0.1-0.5,0-0.7 c-0.1-0.2-0.2-0.4-0.5-0.5c-0.1-0.1-0.5-0.2-1.2-0.5l-1.3-0.5L121.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128.8,35.7l3.3-6.3l-2.2-1.2l0.7-1.3l6,3.1l-0.7,1.3l-2.2-1.2l-3.3,6.3L128.8,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M134.3,38.7l5-6.9l2.1,1.5l-2.1,5.6l4.6-3.8l2.1,1.5l-5,6.9l-1.3-0.9l3.9-5.5l-5.3,4.5l-1.4-1 l2.5-6.4l-3.9,5.5L134.3,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143,45.2l5.9-6.2l4.6,4.4l-1,1l-3.3-3.2l-1.3,1.4l3.1,3l-1,1l-3.1-3l-1.6,1.7l3.4,3.3l-1,1 L143,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.3,51.5l6.7-5.3l1,1.3l-2.3,6.3l4.5-3.5l1,1.3l-6.7,5.3l-1.1-1.4l2.2-6.2l-4.4,3.5L149.3,51.5z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M156,60.7l6.1-3.7l-1.3-2.2l1.2-0.7l3.5,5.8l-1.2,0.7l-1.3-2.2l-6.1,3.7L156,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.9,68.4c0.8-0.3,1.6-0.4,2.2-0.4c0.5,0,0.9,0.2,1.4,0.4c0.4,0.2,0.8,0.5,1.1,0.8 c0.4,0.4,0.7,1,0.9,1.6c0.4,1.2,0.4,2.3-0.1,3.2c-0.5,1-1.4,1.7-2.7,2.2c-1.3,0.5-2.4,0.5-3.4,0c-1-0.4-1.7-1.3-2.1-2.4 c-0.4-1.2-0.4-2.3,0.1-3.2C162.7,69.5,163.6,68.8,164.9,68.4z M165.5,70c-0.9,0.3-1.5,0.8-1.8,1.4c-0.3,0.6-0.4,1.2-0.1,1.9 c0.2,0.6,0.6,1.1,1.3,1.3c0.6,0.3,1.4,0.2,2.3-0.1c0.9-0.3,1.5-0.8,1.8-1.3c0.3-0.6,0.3-1.2,0.1-1.9c-0.2-0.7-0.7-1.1-1.3-1.4 C167.2,69.7,166.4,69.7,165.5,70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.2,79.8l8.4-1.7l1.2,5.7l-1.4,0.3l-0.8-4l-2,0.4l0.7,3.5l-1.4,0.3l-0.7-3.5l-3.6,0.7 L164.2,79.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "76.6,103.5 88.8,103.5 82.7,86.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122,130.9c0-0.4-0.2-0.6-0.5-0.7c-0.4-0.1-0.4-0.3-0.3-0.7c0.2-0.4,0.3-0.9,0.4-1.3 c0.2-1.2,0.5-2.4-1.1-3.1c-0.3-0.1-0.4-0.6-0.7-1c0.2-0.1,0.3-0.2,0.4-0.2c0.5-0.1,1-0.2,1-0.7c0-0.4-0.4-0.7-0.7-1.1 c-0.2-0.2-0.4-0.3-0.6-0.4c0.2-0.3,0.4-0.5,0.6-0.8h-0.1l-10-17.8h-5.1V121h0l0.1,0.2h-9.8L91.7,111H73.9l-5,12.9 c0.5,0.1,0.9,0.6,0.9,1.1c0,2.8,0.1,5.6,0.1,8.5c0,0.8,0,1.6,0,2.4c0.5,0.1,0.9,0.1,1.2,0c16.2,0,32.5-0.1,48.7-0.1 c1.5,0,1.3,0.1,1.3-1.2c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.4c0.6-0.2,0.7-0.6,0.6-1.1C122,131.9,122,131.4,122,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.5,73.9c0.3-0.1,0.7,0.1,1.1,0.1c0-0.2-0.1-0.4-0.1-0.5c-0.3-0.9-0.6-1.1-1.6-1.1 c-3.3,0.1-6.6,0.2-9.9,0.3c-0.3,0-0.6-0.1-0.9-0.1c0.5-2.2,2-3.5,3.7-4.7c0.8-0.6,1-1.5,1.8-2.1c0,0,0-0.1,0-0.1 c-0.1-0.8,0.1-1.6-0.7-2.3c-0.2-0.1-0.3-0.4-0.3-0.6c-0.3-0.7-0.8-1.2-1.5-1.2c-25.9,0-51.8,0-77.6,0c-0.3,0-0.5,0-0.8,0 c0,0.2,0,0.3,0,0.4c0.7,5.7,1.5,11.4,2.3,17.2c0.4,3,0.9,6,0.8,9c-0.2,9.6-0.4,19.1-0.6,28.6L78,76.5h9.5l9.5,23.6V76.6h3.3h5 h11.1c2.4,0,4.6,0.5,6.4,1.6c1.8,1.1,3.3,2.6,4.3,4.7c1,2,1.5,4.3,1.5,7c0,2.6-0.5,5-1.5,7c-1,2-2.5,3.6-4.3,4.7 c-0.9,0.5-1.9,0.9-2.9,1.2l5,8.6c0.1-0.1,0.2-0.2,0.3-0.2c0.7-0.5,1.3-1,1.6-1.8c0.2-0.4,0.5-0.9,1.2-0.6c0.1-0.7,0.2-1.4,0.3-2.2 c1.2,0.6,1.8-0.3,2.4-0.8c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0.1-1.1,0-2.3,0.1-3.4c0-0.7,0.2-1.5,0.4-2.2 c0.1-0.2,0.4-0.4,0.6-0.4c1.2-0.1,1.4-0.2,1.2-1.4c-0.1-0.4,0.1-0.5,0.4-0.7c0.6-0.3,1.2-0.5,1.8-0.8c1.4-0.7,1.6-1.3,0.9-2.6 c-0.3-0.4-0.2-0.7,0.3-0.9c0.7-0.2,1.3-0.7,1.5-1.5c0.2-0.5,0.4-0.9,1.1-0.7c0.5,0.1,0.7-0.1,0.7-0.5c0-0.7,0-1.4-0.2-2.1 c-0.4-1.4-0.2-2.7,1-3.7c0.2-0.2,0.5-0.4,0.5-0.7c0-0.7,0.4-1.2,1.2-1.4c0.6-0.2,0.6-0.5,0.5-1c-0.1-0.4-0.1-0.8,0.1-1.1 c0.2-0.4,0.3-0.7-0.1-1.1c-0.4-0.4-0.3-0.8,0.1-1.2c0.2-0.2,0.4-0.3,0.6-0.4c0.7-0.3,1.4-0.6,2-1c1.1-0.6,1.1-0.9,0.1-1.5 c-0.1-0.1-0.1-0.1-0.2-0.3C145.9,74.3,146.2,74,146.5,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118,94.4c0.7-0.4,1.2-1,1.5-1.8c0.4-0.8,0.5-1.7,0.6-2.7c0-1-0.2-2-0.5-2.7 c-0.4-0.8-0.9-1.4-1.5-1.8c-0.7-0.4-1.4-0.6-2.3-0.6h-10.4v10.4h10.4C116.6,95.1,117.4,94.9,118,94.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -21.6177 8.204)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 24.4,
    cy: 96.9,
    rx: 2.8,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.7,
    cy: 96.9,
    r: 2.8
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appLogo.2e2e17ae.svg";
export { ForwardRef as ReactComponent };